// @core/api/endpoints/localization/search_translation_keys.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTranslationKeysResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Search translation keys
 * Full-text search across key names, source text, and translations.
 */
export async function SearchTranslationKeys(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTranslationKeysResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/keys/search`;
  const requestOptions = options;
  return client.get<ListTranslationKeysResponse>(requestPath, { ...requestOptions, params });
}
